<script>
import Vue from 'vue';
import { RichTextEditorPlugin, Toolbar, Link, 
  Image, Count, HtmlEditor, QuickToolbar, Table } from "@syncfusion/ej2-vue-richtexteditor";
Vue.use(RichTextEditorPlugin);
import { Validator } from "@/plugins/validator";
import { dischargeSummaryMetaFields as metaFields } from "./metaFields";
import AddDischargeMedication from "./discharge/Treatment.vue";
import AddDischargeAppointment from "./discharge/Appointments.vue";

export default {
    name: "PatientInitiateDischarge",

    data() {

      return {
        templateID: 0,
        consultantName: ``,
        errors: [],
        addMedication: false,
        addAppointment: false,
        prescriptions: [],
        appointments: [],
        departments: [],
        ndtreatments: [],
      };
    },

    props: {

        patient: Object,
        showModal: Boolean,
        templates: Array,
        clinicians: Array,
        dischargeSummary: Object,
    },

    watch: {

      templateID() {
        if(!this.templateID && !this.templates.length) return;

        const templates = this.templates.filter(tmp => tmp.tempID == this.templateID);

        this.dischargeSummary.recommendations = templates.length ? templates[0].template : ``;
      },
      consultantName() {
        this.dischargeSummary.clinician = this.consultantName;
        if(!this.clinicians.id && !this.clinicians.length) return;

        const consultant = this.clinicians.filter(tmp => tmp.names == this.consultantName);

        this.dischargeSummary.clinicianId = consultant.length ? consultant[0].id : ``;
      },
      showModal() {
        if(!this.showModal) return;

          this.fetchAppointments();
          this.fetchPrescriptions();
          this.fetchNDTreatments();
      },
    },

    provide: {

     richtexteditor:[ Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table ]
    },

    methods: {

      async fetchDischargeMedication() {

          try {
              this.$root.loading = true;

              await Promise.all([ this.fetchNDTreatments(), this.fetchPrescriptions(), ]);

              this.$root.loading = false;

              return Promise.resolve();
          } catch {
            this.$root.loading = false;

            return Promise.reject();
          }
      },

      fetchPrescriptions() {
        let url = `MedicalFile/GetPatientDrugsandConsumblesTreatmentforDischarge`;
            url += `?PatientID=${this.patient.patienT_ID}`;
            url += `&VisitNo=${this.patient.visitNo}`;

        return this.$http.get(url).then(({data}) => {
                this.prescriptions = data;
             }).catch(() => {});
      },

      fetchClinics() {

        return this.$http.get(`Shared/GetDepartments`).then(({data}) => {
          this.departments = data;
        }).catch(() => {});
      },

      fetchAppointments() {
        const patientID = this.dischargeSummary.patientID || this.patient.patienT_ID;
        const visitNo = this.dischargeSummary.visitNo || this.patient.visitNo;

        let url = `MedicalFile/GetPatientAppointments`;
            url += `?PatientID=${patientID}`;
            url += `&VisitNo=${visitNo}`;

        return this.$http.get(url).then(({data}) => {
          this.appointments = data;
        }).catch(() => {});
      },

      fetchNDTreatments() {
        const patientID = this.dischargeSummary.patientID || this.patient.patienT_ID;
        const visitNo = this.dischargeSummary.visitNo || this.patient.visitNo;

        let url = `MedicalFile/GetNoneDrugTreatment`;
            url += `?PatientID=${patientID}`;
            url += `&VisitNo=${visitNo}`;

        return this.$http.get(url).then(({data}) => {
          this.ndtreatments = data;
        }).catch(() => {});
      },

      async fetchSharedData() {

        try {
          this.$root.loading = true;
          await Promise.all([this.fetchClinics(), this.fetchAppointments(), ]);
          this.$root.loading = false;

          return Promise.resolve();
        } catch {
          this.$root.loading = false;

          return Promise.reject();
        }
      },

      SaveDataWithAppointmentscheck() {
        if(!this.appointments.length>0){
          let message=`Kindly Enter the Appointments to proceed`;
          window.Swal.fire({ type: `error`, text:message});
        }else{
          this.SaveData();
        }
      },
      SaveData() {

        new Validator(this.dischargeSummary, metaFields).validate().then(() => {
          this.errors = [];
          this.$root.loading = true;
          const dischargeSummary = {
            ...this.dischargeSummary,
            clinician:this.consultantName,
            userName: this.$root.username,
            patientID: this.dischargeSummary.patientID ? this.dischargeSummary.patientID : this.patient.patienT_ID, 
            visitNo: this.dischargeSummary.visitNo ? this.dischargeSummary.visitNo : this.patient.visitNo,
          };
          this.$http.post(`Admissions/PatientDischargeSummary`, dischargeSummary).then(response => {
            this.$emit(`refresh`);
            this.$root.loading = false;
            this.$emit(`closeModal`);
            window.Swal.fire({ type: `success`, text: response.data });
          }).catch(() => { this.$root.loading = false; });
        }).catch(errors => { this.errors = errors; });
      },

      cancelDischargeDrugs(drug) {
        if(!window.confirm(`cancel discharge drugs`)) return;

        const cancelDrug = {
          id: drug.code,
          patientID: drug.patientId,
          visitNo: drug.visitNo,
          itemName: drug.service,
          userName: this.$root.username,
        };

        this.$root.loading = true;
        this.$http.post(`MedicalFile/RemovePrescriptionFromDischargeSummary`, cancelDrug).then(() => {
          this.fetchPrescriptions();
          this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
      },
    },

    components: {

      "add-discharge-medication": AddDischargeMedication,
      "add-discharge-appointment": AddDischargeAppointment,
    },
}
</script>
<template>
  <tail-modal :show="showModal" dimension="md:w-2/3 sm:w-11/12">
    <template v-slot:title>
      <h5 class="text-sm font-medium">Initiate Discharge</h5> 
    </template>
    <template v-slot:modal-body>
      <div class="flex flex-wrap -m-3">
        <div class="w-full flex md:flex-row sm:flex-col bg-gray-400 p-1 mb-1 rounded">
          <div class="flex-1">
            <h5 class="font-bold text-sm">Name: 
                <span class="text-blue-800">{{ patient.names }}</span></h5>
          </div>
          <div class="flex-1">
            <h5 class="font-bold text-sm">MRN: 
                <span class="text-blue-800">{{ patient.patienT_ID }}</span></h5>
          </div>
          <div class="flex-1">
            <h5 class="font-bold text-sm">IP File No: 
                <span class="text-blue-800">{{ patient.ipfileno }}</span></h5>
          </div>
          <div class="flex-1">
            <h5 class="font-bold text-sm">Gender: 
                <span class="text-blue-800">{{ patient.gender }}</span></h5>
          </div>
          <div class="flex-1">
            <h5 class="font-bold text-sm">DOB: 
                <span class="text-blue-800">{{ patient.dob | dateFormat }}</span></h5>
          </div>
        </div>
        <div class="w-1/2 md:w-1/4 p-tiny">
          <label for="grid-admission-date" class="label-control">Admission Date:</label>
          <input type="date"
            :disabled="$root.checkAuth(`DisableDischargeDate`)"
            v-model.trim="dischargeSummary.dateofAdmission"
            name="grid-admission-date" id="grid-admission-date" 
            class="input-control input-sm text-xs">
        </div>
        <div class="w-1/2 md:w-1/4 p-tiny">
          <label for="grid-discharge-date" class="label-control">Discharge Date:</label>
          <input type="date"
            :disabled="$root.checkAuth(`DisableDischargeDate`)"
            v-model.trim="dischargeSummary.dateofDischarge"
            name="grid-discharge-date" id="grid-discharge-date" 
            class="input-control input-sm text-xs">
            <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'dateofDischarge').length">
                  {{ errors.filter(error => error.field == 'dateofDischarge')[0].message }}</p>
        </div>
        <!-- <div class="w-1/2 md:w-1/4 p-tiny">
          <label for="grid-tca" class="label-control">TCA/Review Date:</label>
          <input type="date" 
            v-model.trim="dischargeSummary.nextClinicAppointmentDate" 
            id="grid-tca" class="input-control input-sm text-xs">
        </div>
        <div class="w-1/2 md:w-1/4 p-tiny">
          <label for="grid-clinician" class="label-control">Clinician:</label>
          <v-select 
            v-model.trim="consultantName"
            :options="clinicians" label="names"
            :reduce="clinician => clinician.names"
            id="grid-clinician" class="bg-white text-xs">
          </v-select>
          <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'clinician').length">
                  {{ errors.filter(error => error.field == 'clinician')[0].message }}</p>
        </div> -->
        <div class="w-full md:w-1/2 p-tiny">
          <label for="grid-diagnosis-admission" class="label-control">Diagnosis On Admission:</label>
          <textarea
            v-model.trim="dischargeSummary.diagnosisonAdmission"
            id="grid-diagnosis-admission" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
        </div>
        <div class="w-full md:w-1/2 p-tiny">
          <label for="grid-diagnosis-on-discharge" 
            class="label-control">Diagnosis On Discharge:</label>
          <textarea 
            v-model.trim="dischargeSummary.diagnosisonDischarge"
            id="grid-diagnosis-on-discharge" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
          <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'diagnosisonDischarge').length">
                  {{ errors.filter(error => error.field == 'diagnosisonDischarge')[0].message }}</p>
        </div>
        <div class="w-full md:w-1/2 p-tiny">
          <label for="grid-major-presenting-complains" 
            class="label-control">Major/Relevant Presenting Complains and Brief History:</label>
          <textarea
            v-model.trim="dischargeSummary.majorComplaints" 
            id="grid-major-presenting-complains" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
        </div>
        <div class="w-full md:w-1/2 p-tiny">
          <label for="grid-major-physical-findings" 
            class="label-control">Major/Relevant Physical Findings at Admission:</label>
          <textarea 
            v-model.trim="dischargeSummary.physicalFindings"
            id="grid-major-physical-findings" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
        </div> <div class="w-full md:w-1/2 p-tiny">
          <label for="grid-major-physical-findings" 
            class="label-control">Major/Relevant Physical Findings at Discharge:</label>
          <textarea 
            v-model.trim="dischargeSummary.physicalFindingsatdischarge"
            id="grid-major-physical-findings" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
        </div>
        <div class="w-full md:w-1/2 p-tiny">
          <label for="grid-investigations-done" 
            class="label-control">Investigations Done:</label>
          <textarea 
            v-model.trim="dischargeSummary.investigationsdone"
            id="grid-investigations-done" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
        </div>
        <div class="w-full md:w-1/2 p-tiny">
          <label for="grid-surgical-medical-procedure-done" 
            class="label-control">Surgical/Medical Procedures Done:</label>
          <textarea 
            v-model.trim="dischargeSummary.proceduresdone"
            id="grid-surgical-medical-procedure-done" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
        </div>
        <div class="w-full md:w-1/2 p-tiny" v-if="$root.checkAuth('DisplayDrugReceivedOnDischargeSummary')">
          <label for="grid-drugs-received" class="label-control">Drugs Received:</label>
          <textarea 
            v-model.trim="dischargeSummary.drugsReceived"
            id="grid-drugs-received" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
        </div>
        <div class="w-full md:w-1/2 p-tiny">
          <label for="grid-progress" class="label-control">Condition/Progress on Discharge:</label>
          <textarea 
            v-model.trim="dischargeSummary.progress" id="grid-progress" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
        </div>
        <div class="w-full md:w-1/2 p-tiny">
          <label for="grid-progress" class="label-control">Post Procedure Status:</label>
          <textarea 
            v-model.trim="dischargeSummary.postprocedurestatus" id="grid-progress" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
        </div>
        <div class="w-full md:w-1/2 p-tiny">
          <label for="grid-progress" class="label-control">Special Instruction:</label>
          <textarea 
            v-model.trim="dischargeSummary.specialInstructions" id="grid-progress" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
        </div> <div class="w-full md:w-1/2 p-tiny">
          <label for="grid-progress" class="label-control">Warning Signs:Return to Hospital if you Experience</label>
          <textarea 
            v-model.trim="dischargeSummary.warningSigns" id="grid-progress" cols="30" rows="2" 
            class="input-control input-sm text-xs"></textarea>
        </div> <div class="w-full flex flex-wrap p-2 bg-gray-300 my-1">
          <div class="flex-1">
            <h5 class="text-sm font-medium">Discharge Medication</h5>
          </div>
          <div class="flex-1 text-right">
            <button @click.prevent="fetchDischargeMedication().then(() => { addMedication = true; })"
              class="btn-sm btn-primary text-xs rounded mr-4">Add Discharge Treatment</button> 
          </div>
          <add-discharge-medication 
            :prescriptions="prescriptions" 
            :showModal="addMedication"
            :clinicians="clinicians"
            :patient="patient"
            :ndtreatments="ndtreatments"
            @refresh="fetchDischargeMedication()"
            @closeModal="addMedication = false"
          />
        </div>
        <div class="w-full overflow-auto my-2">
            <table class="table">
                <thead class="bg-blue-500 text-white text-xs">
                    <tr>
                        <th class="p-tiny">Id</th>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Prescription</th>
                        <th class="p-tiny">Requested By</th>
                        <th class="p-tiny">Action</th>
                    </tr>
                </thead>
                <tbody class="bg-gray-100 text-xs">
                    <tr v-for="presc in prescriptions" :key="presc.code">
                        <td class="p-tiny">{{ presc.code }}</td>
                        <td class="p-tiny">{{ presc.drug }}</td>
                        <td class="p-tiny">{{ presc.description || `-` }}</td>
                        <td class="p-tiny">{{ presc.requested_By }}</td>
                        <td class="p-tiny">
                          <button 
                            @click.prevent="cancelDischargeDrugs(presc)"
                            class="btn-sm btn-danger text-xs rounded">
                            <i class="fa fa-times"></i> Cancel</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="table text-xs mt-2">
                <thead class="bg-blue-500 text-white">
                    <tr>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Done By</th>
                        <th class="p-tiny w-56 break-words">Notes</th>
                        <th class="p-tiny">Action</th>
                    </tr>
                </thead>
                <tbody class="text-xs bg-gray-200">
                    <tr v-for="ndtreatment in ndtreatments" :key="ndtreatment.id">
                        <td class="p-tiny">{{ndtreatment.trxDate | dateFormat}}</td>
                        <td class="p-tiny">{{ndtreatment.userName}}</td>
                        <td class="p-tiny w-56 break-words">
                            <span v-html="ndtreatment.description"></span>
                        </td>
                        <td class="p-tiny">
                            <button @click.prevent="noneDrugTreatment = ndtreatment"
                                class="btn-sm text-xs btn-primary rounded">
                                <i class="fa fa-edit"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full flex flex-wrap p-2 bg-gray-300 my-1">
          <div class="flex-1">
            <h5 class="text-sm font-medium">Doctor Appointments/Appointment for Review</h5>
          </div>
          <div class="flex-1 text-right">
            <button @click.prevent="fetchSharedData().then(() => { addAppointment = true; })"
              class="btn-sm btn-info text-xs rounded">Add Appointments</button>
          </div>
          <add-discharge-appointment 
            :patient="patient"
            :showModal="addAppointment"
            :departments="departments"
            :clinicians="clinicians"
            :appointments="appointments"
            @refresh="fetchAppointments"
            @closeModal="addAppointment = false"
          />
        </div>
        <div class="w-full overflow-auto">
            <table class="table table-hover">
                <thead class="bg-blue-500 text-white text-sm">
                   <tr class="w-full flex">
                       <th class="p-tiny flex-1">Doctor</th>
                       <th class="p-tiny flex-1">Clinic</th>
                       <th class="p-tiny flex-1">Date</th>
                       <th class="p-tiny flex-1">Time</th>
                   </tr> 
                </thead>
                <tbody 
                    class="bg-gray-100 text-sm flex flex-col items-center overflow-auto" 
                    style="max-height:35vh;">
                    <tr v-for="(app, idx) in appointments" class="w-full flex" :key="idx">
                        <td class="p-tiny flex-1">{{ app.doctor }}</td>
                        <td class="p-tiny flex-1">{{ app.clinic }}</td>
                        <td class="p-tiny flex-1">{{ app.appointmentDate.getDay }}</td>
                        <td class="p-tiny flex-1">{{ app.startTime }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="md:w-1/4 w-1/2 p-tiny">
          <label for="grid-verified-by" class="label-control">Verified By:</label>
          <v-select 
            v-model.trim="dischargeSummary.verifiedBy"
            :options="clinicians" label="names"
            :reduce="clinician => clinician.names"
            id="grid-clinician" class="bg-white text-xs">
          </v-select>
            <p class="form-text-error" 
              v-if="errors.filter(error => error.field == 'verifiedBy').length">
                  {{ errors.filter(error => error.field == 'verifiedBy')[0].message }}</p>
        </div>
        <div class="w-1/2 md:w-1/4 p-tiny">
          <label for="grid-template" class="label-control">Template:</label>
          <tail-select>
            <template v-slot:field>
              <select v-model="templateID" id="grid-template" class="input-control input-sm text-xs">
                <option :value="0">select template</option>
                <option v-for="(tem, idx) in templates" :key="idx" :value="tem.tempID">{{ tem.tempName }}</option>
              </select>
            </template>
          </tail-select>
        </div>
        <!-- <div class="w-full p-tiny">
          <label class="label-control">Comment:</label>
          <ejs-richtexteditor v-model.trim="dischargeSummary.recommendations" 
              ref="initiateDischargeRTE" :height="150" :toolbarSettings="{
                  items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
                  'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
                  'LowerCase', 'UpperCase', 'SuperScript', 'SubScript' , '|',
                  'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
                  'Outdent', 'Indent', '|', 'CreateTable', 'CreateLink', 'Image', '|',
                  'ClearFormat', 'Print', 'SourceCode', 'FullScreen', '|', 'Undo', 'Redo']
              }">
          </ejs-richtexteditor>
        </div> -->
      </div>
    </template>
    <template v-slot:modal-footer>
      <button class="btn-danger btn-sm text-xs rounded mr-6" @click.prevent="$emit(`closeModal`)">
        <i class="fa fa-times"></i> Cancel</button>
      <button class="btn-primary btn-sm text-xs rounded" @click.prevent="SaveDataWithAppointmentscheck">
        <i class="fa fa-save"></i> Save</button>
    </template>
  </tail-modal>
</template>
